import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from "@material-ui/core/Grid";
import translate from '../other/translate.json';
import clsx from 'clsx';
import config from '../other/config';
import DoneIcon from '@material-ui/icons/Done';
import DoneAllIcon from '@material-ui/icons/DoneAll';

import utils from '../other/utils'
import { Close } from '@material-ui/icons';
import { Tooltip } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

const { serverAPI } = config;

const DecIcon1 = (props) => (
  <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.5 4.5H11.5" stroke="black" stroke-linecap="round" />
    <path d="M4.5 4.5H11.5" stroke="black" stroke-linecap="round" />
    <path d="M4.5 7.5H11.5" stroke="black" stroke-linecap="round" />
    <path d="M4.5 10.5H9.5" stroke="black" stroke-linecap="round" />
  </svg>
)

const DecIcon = (props) => {
  return (
    <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.43945 3C1.43945 2.44772 1.88717 2 2.43945 2H3.9796C5.42324 2 6.66217 3.02822 6.92822 4.44713L7.06938 5.2H19.2785C21.1324 5.2 22.5425 6.8646 22.2377 8.6932L21.3044 14.2932C21.0633 15.7398 19.8117 16.8 18.3452 16.8H9.69931C8.25566 16.8 7.01674 15.7718 6.75069 14.3529L4.96247 4.81571C4.87379 4.34274 4.46082 4 3.9796 4H2.43945C1.88717 4 1.43945 3.55228 1.43945 3Z" fill={props.fill} />
      <path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M10.5 22C11.3284 22 12 21.3284 12 20.5C12 19.6716 11.3284 19 10.5 19C9.67157 19 9 19.6716 9 20.5C9 21.3284 9.67157 22 10.5 22Z" fill={props.fill} />
      <path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M16.5 22C17.3284 22 18 21.3284 18 20.5C18 19.6716 17.3284 19 16.5 19C15.6716 19 15 19.6716 15 20.5C15 21.3284 15.6716 22 16.5 22Z" fill={props.fill} />
    </svg>
  );
}

const TestIcon = (props) => (
  <svg {...props} width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7.5" cy="8.04004" r="7.5" fill="#FE9D67" />
  </svg>

)

const CustomTypography = withStyles((theme) => ({
  h1: {
    fontSize: '40px',
    lineHeight: '48px',
    fontWeight: '500',
    color: '#24262A'
  },

  body1: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: '400',
    color: '#8987A2'
  },

  gutterBottom: {
    marginBottom: 20
  },
}))(Typography);

export default function KloStatus(props) {
  const classes = useStyles();
  const { kloStatus, codeasvul, loadingKloStatuses } = props
  // const loadingKloStatuses = true
  //const kloStatus = props.kloStatuses && props.kloStatuses[props.data.codeasvul] ? props.kloStatuses[props.data.codeasvul] : '';	
  const kloUser = props.kloUser;
  const kloHref = `${utils.getKLOLink()}/monthly/${utils.getKLOMonth()}?server_part=${kloUser && kloUser.currentServerPart ? kloUser.currentServerPart : ''}&codeasvul=${codeasvul}`
  const RenderStatus = (statusFromKlo, loading) => {
    if (loading === true) {
      return (
        <Skeleton animation="wave" variant="rect" width={81} height={32} style={{ width: '81px', borderRadius: 16 }} />
      )
    } else {
      let { status, hasDecision } = typeof statusFromKlo === 'object' ? statusFromKlo : {};
      //let decStatus = `В процессе оформления покупки (${status.replace('КУПЛЕНО','').replace('НЕ КУПЛЕНО','')}`
      if (status === 'КУПЛЕНО') {
        return (
          <Typography >
            <a className={classes.kloLinkBuy} href={kloHref} target="_blanc" style={{ fontSize: props.isApp === true ? 16 : undefined }}>
              {/* <DoneIcon className={classes.iconLinkBuy} />  */}
              Куплено</a>
          </Typography>
        )
      } else if (status === 'В процессе оформления покупки') {
        return (
          <Typography >
            <a className={classes.kloLinkDec} href={kloHref} target="_blanc" style={{ fontSize: props.isApp === true ? 16 : undefined }}>
              {/* <DecIcon className={classes.iconLinkDec}/> */}
              В процессе оформления покупки </a>
          </Typography>
        )
      } else if (status === 'НЕ КУПЛЕНО') {
        return (
          <Typography >
            <a className={classes.kloLinkNotBuy} href={kloHref} target="_blanc" style={{ fontSize: props.isApp === true ? 16 : undefined }}>
              {/* <Close className={classes.iconLinkNotBuy}/> */}
              Не куплено </a>
          </Typography>
        )
      } else if (status === 'НЕ КУПЛЕНО (НЕ ИСПОЛЬЗУЕТСЯ)') {
        return (
          <div >
            <a className={classes.kloLinkNotBuy} href={kloHref} target="_blanc" style={{ fontSize: props.isApp === true ? 16 : undefined }}>
              {hasDecision ? <Tooltip title='В процессе оформления покупки'><div> <DecIcon fill={'#f90'} className={classes.iconLinkDec} /></div></Tooltip> : null}
              <div>
                <div> Не куплено</div>
                <div>  (не используется)</div>
              </div>
            </a>
          </div>
        )
      } else if (status === 'НЕ КУПЛЕНО (ИСПОЛЬЗУЕТСЯ)') {
        return (
          <div >
            <a className={classes.kloLinkNotBuy} href={kloHref} target="_blanc" style={{ fontSize: props.isApp === true ? 16 : undefined }}>
              {hasDecision ? <Tooltip title='В процессе оформления покупки'><div> <DecIcon fill={'#f90'} className={classes.iconLinkDec} /></div></Tooltip> : null}
              <div>
                <div> Не куплено</div>
                <div>  (используется)</div>
              </div>
            </a>
          </div>
        )
      } else if (status === 'КУПЛЕНО (ИСПОЛЬЗУЕТСЯ)') {
        return (
          <div >
            <a className={classes.kloLinkBuy} href={kloHref} target="_blanc" style={{ fontSize: props.isApp === true ? 16 : undefined }}>
              {/* <div> <DoneAllIcon className={classes.iconLinkBuy}/></div> */}
              {hasDecision ? <Tooltip title='В процессе оформления покупки'><div> <DecIcon fill={'#f90'} className={classes.iconLinkDec} /></div></Tooltip> : null}
              <div>
                <div>Куплено</div>
                <div>  (используется)</div>
              </div>
            </a>
          </div>
        )
      }
      else if (status === 'КУПЛЕНО (НЕ ИСПОЛЬЗУЕТСЯ)') {
        return (
          <div >
            <a className={classes.kloLinkBuy} href={kloHref} target="_blanc" style={{ fontSize: props.isApp === true ? 16 : undefined }}>
              {/* <div> <DoneIcon className={classes.iconLinkBuy}/></div> */}
              {hasDecision ? <Tooltip title='В процессе оформления покупки'><div> <DecIcon fill={'#f90'} className={classes.iconLinkDec} /></div></Tooltip> : null}
              <div>
                <div >Куплено</div>
                <div>  (не используется)</div>
              </div>
            </a>
          </div>
        )
      }
      else if (status === 'КУПЛЕНО') {
        return (
          <Typography >
            <a className={classes.kloLinkBuy} href={kloHref} target="_blanc" style={{ fontSize: props.isApp === true ? 16 : undefined }}>
              {/* <DoneIcon className={classes.iconLinkBuy}/> */}
              Куплено </a>
          </Typography>
        )
      }



      else {
        return null
      }
    }
  }


  return (


    RenderStatus(kloStatus, loadingKloStatuses)

  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: '100%',
    backgroundColor: '#F6F6FB',
    borderRadius: 16,
    boxShadow: 'none',
    padding: 24,
    height: 'fit-content',

    [theme.breakpoints.down(696)]: {
      padding: 0,
      backgroundColor: 'transparent',
    }
  },

  kloLinkBuy: {
    color: 'rgb(129, 211, 157)',
    fontSize: '13px',
    lineHeight: '16px',
    fontFamily: 'Cera CY',
    fontWeight: 400,
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    borderBottom: '1px solid',
    borderColor: 'inherit',

    '&:hover': {
      color: '#2050FF',
      textDecoration: 'none',
      borderBottom: '1px solid #2050FF',
    }
  },

  kloLinkNotBuy: {
    color: 'rgba(235, 80, 94, 1)',
    fontSize: '13px',
    lineHeight: '16px',
    fontFamily: 'Cera CY',
    fontWeight: 400,
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    borderBottom: '1px solid',
    borderColor: 'inherit',

    '&:hover': {
      color: '#2050FF',
      textDecoration: 'none',
      borderBottom: '1px solid #2050FF',
    }
  },

  kloLinkTest: {
    color: 'rgba(254, 157, 103, 1)',
    fontSize: '13px',
    lineHeight: '16px',
    fontFamily: 'Cera CY',
    fontWeight: 400,
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    borderBottom: '1px solid',
    borderColor: 'inherit',

    '&:hover': {
      color: '#2050FF',
      textDecoration: 'none',
      borderBottom: '1px solid #2050FF',
    }
  },

  kloLinkDec: {
    color: 'rgba(36, 38, 42, 1)',
    fontSize: '13px',
    lineHeight: '16px',
    fontFamily: 'Cera CY',
    fontWeight: 400,
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    borderBottom: '1px solid',
    borderColor: 'inherit',

    '&:hover': {
      color: '#2050FF',
      textDecoration: 'none',
      borderBottom: '1px solid #2050FF',
    }
  },

  iconLinkBuy: {
    color: 'rgba(129, 211, 157, 0.83)',
    width: 14,
    height: 14,
    marginRight: 6
  },

  iconLinkTest: {
    color: 'rgba(254, 157, 103, 1)',
    width: 14,
    height: 14,
    marginRight: 6
  },

  iconLinkDec: {
    //color:'rgba(254, 157, 103, 1)',
    color: '#ff9900',
    width: 14,
    height: 14,
    marginRight: 4
  },

  iconLinkNotBuy: {
    color: 'rgba(61, 64, 71, 1)',
    width: 14,
    height: 14,
    marginRight: 6
  },

  LinkType2: {
    // fontFamily: 'Cera CY',
    // fontStyle: 'normal',
    // fontWeight: 'normal',
    // fontSize: '16px',
    // lineHeight: '24px',
    // color: '#24262A',

    // '& * > a': {
    color: '#24262A !important',
    textDecoration: 'none',
    borderBottom: '1px solid rgba(0, 0, 0, 0.4)',

    '&:hover': {
      color: '#2050FF !important',
      textDecoration: 'none',
      borderBottom: '1px solid #2050FF',
    }
  }
}));